$(function(){
  $("body > .loading__spinner:not(.hidden), main > .loading__spinner:not(.hidden), #MainContent > .loading__spinner:not(.hidden)").addClass("hidden");

  updateSwiper();
  $(".custom-hero-slider-swiper").each(function(){
    this.swiper.slideTo(1);
  })
  $(".custom-hero-slider-navigation-prev").click(function(){
    $(this).parents(".custom-hero-slider-swiper-wrapper").find(".custom-hero-slider-swiper")[0].swiper.slidePrev();
  })
  $(".custom-hero-slider-navigation-next").click(function(){
    $(this).parents(".custom-hero-slider-swiper-wrapper").find(".custom-hero-slider-swiper")[0].swiper.slideNext();
  })
  $(".custom-fc-navigation-prev").click(function(){
    $(this).parents(".custom-fc").find(".custom-fc-swiper")[0].swiper.slidePrev();
  })
  $(".custom-fc-navigation-next").click(function(){
    $(this).parents(".custom-fc").find(".custom-fc-swiper")[0].swiper.slideNext();
  })
  $(".custom-faq-title").click(function(){
    $(this).toggleClass("active");
    $(this).next(".custom-faq-content").slideToggle(300);
  })
  $(".custom-our-values-img-wrapper").click(function(){
    if($(this).attr("data-min") != undefined && $(this).attr("data-max") != undefined){
      let min = parseInt($(this).attr("data-min"));
      let max = parseInt($(this).attr("data-max"));
      let final = min + 100;
      $(this).find(".custom-our-values-img").attr("style", `transform: translateY(-${final}%)`);
      $(this).parents(".custom-our-values").find(".custom-our-values-main-img").attr("style", `transform: translateY(-${final}%)`);
      $(this).attr("data-min", final);
      if(max == final){
        $(this).addClass("custom-our-value-none");
      }
    }
  })
  /*
  if($(".custom-slider-swiper").length > 0){
    $(".custom-slider-swiper").each(function(){
      let $this = $(this);
      let $section = $this.parents(".custom-slider");
      let $wrapper = $section.find(".custom-slider-wrapper");
      let total = $(this).find(".custom-slider-slide").length;
      let cbg = $wrapper.attr("data-cbg") || "#008460";
      let cfg = $wrapper.attr("data-cfg") || "#ffffff";
      let cursorHtml = "<div class=\"custom-slider-cursor-follower\" style=\"background:" + cbg + "; color:" + cfg + ";\" aria-hidden=\"true\">" +
        "<svg class=\"custom-slider-navigation-prev\" width=\"16\" height=\"31\" viewBox=\"0 0 16 31\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.0839 2.18418L2.95264 13.3154C2.32538 13.9519 1.97375 14.8096 1.97375 15.7032C1.97375 16.5968 2.32538 17.4546 2.95264 18.091L14.0839 29.2223\" stroke=\"currentColor\" stroke-width=\"2.53482\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>" +
        "<span>1 / " + total + "</span>" +
        "<svg class=\"custom-slider-navigation-next\" width=\"15\" height=\"31\" viewBox=\"0 0 15 31\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1.57412 29.2223L12.7054 18.0911C13.3326 17.4546 13.6843 16.5969 13.6843 15.7033C13.6843 14.8096 13.3326 13.9519 12.7054 13.3155L1.57413 2.1842\" stroke=\"currentColor\" stroke-width=\"2.53482\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>" +
        "</div>";
      let $layer = $("<div class=\"custom-slider-cursor-layer\" aria-hidden=\"true\"></div>");
      let $cursor = $(cursorHtml).appendTo($layer);
      $layer.appendTo("body");
      $section.data("cursorClone", $cursor);
      $section.data("cursorLayer", $layer);
      let cursorReady = false;
      let lastClientX = 0, lastClientY = 0;
      function onDocMouseMove(e) {
        lastClientX = e.clientX;
        lastClientY = e.clientY;
        if (!cursorReady) {
          cursorReady = true;
          $layer.addClass("is-visible").css({ display: "block", visibility: "visible" });
          $section.addClass("custom-slider-cursor-active");
        }
        $cursor.css({ left: e.clientX + "px", top: e.clientY + "px" });
      }
      function hideCursor() {
        $section.removeClass("custom-slider-cursor-active");
        $layer.removeClass("is-visible").css({ display: "", visibility: "" });
        cursorReady = false;
        $(document).off("mousemove", onDocMouseMove);
      }
      $section.on("mouseenter", function(e){
        if ($(window).width() <= 749) return;
        $(document).on("mousemove", onDocMouseMove);
        if (e.clientX != null && e.clientY != null) {
          lastClientX = e.clientX;
          lastClientY = e.clientY;
          cursorReady = true;
          $layer.addClass("is-visible").css({ display: "block", visibility: "visible" });
          $section.addClass("custom-slider-cursor-active");
          $cursor.css({ left: e.clientX + "px", top: e.clientY + "px" });
        }
      });
      $section.on("mouseleave", function(e){
        var sectionEl = $section[0];
        var layerEl = $layer[0];
        var x = cursorReady ? lastClientX : (e.clientX != null ? e.clientX : lastClientX);
        var y = cursorReady ? lastClientY : (e.clientY != null ? e.clientY : lastClientY);
        setTimeout(function() {
          var under = document.elementFromPoint(x, y);
          if (under && (sectionEl.contains(under) || layerEl.contains(under))) return;
          hideCursor();
        }, 0);
      });
      if (this.swiper) {
        this.swiper.on('slideChange', function (e) {
          let ind = e.activeIndex + 1;
          $cursor.find("span").text(ind + " / " + total);
        });
      }
    })
  }
  */
  $(".custom-video-overlay").click(function(){
    $(this).fadeOut("300");
    $(this).parents(".custom-video-main").find(".custom-video-vid")[0].muted = false;
  })
})
$(window).resize(function(){
  updateSwiper();
})
function updateSwiper(){
  if($(".custom-hero-slider-swiper").length > 0){
    if($(window).width() <= 749){
      $(".custom-hero-slider-swiper").attr("slides-per-view", "1.5");
      $(".custom-hero-slider-swiper").attr("space-between", "5");
    }
    else if($(window).width() <= 989){
      $(".custom-hero-slider-swiper").attr("slides-per-view", "2");
      $(".custom-hero-slider-swiper").attr("space-between", "16");
    }
    else{
      $(".custom-hero-slider-swiper").attr("slides-per-view", "2.5");
      $(".custom-hero-slider-swiper").attr("space-between", "16");
    }
  }
}

$(".custom-megamenu-toggle").hover(function(){
  $(".header-wrapper").addClass("custom-megamenu-active");
}, function(){
  $(".header-wrapper").removeClass("custom-megamenu-active");
})
$(".custom-mobile-menu-header svg").click(function(){
  $(this).parents(".menu-drawer-container").find(".header__icon--menu").trigger("click");
})

$(document).on("click", ".custom-fc-qty-plus", function(e){
  var $input = $(this).parent().find(".custom-fc-qty-input");
  var step = parseInt($input.attr("data-min"), 10) || 1;
  var qty = (parseInt($input.val(), 10) || 0) + step;
  $input.val(qty);
})
$(document).on("click", ".custom-fc-qty-minus", function(e){
  var $input = $(this).parent().find(".custom-fc-qty-input");
  var step = parseInt($input.attr("data-min"), 10) || 1;
  var min = step;
  var qty = parseInt($input.val(), 10) || min;
  if (qty > min) {
    var fqty = Math.max(min, qty - step);
    $input.val(fqty);
  }
})

$(document).on("click", ".custom-back-to-top", function(){
   $("html, body").animate({ scrollTop: 0 }, 1000);
})

$(document).on("click", ".custom-blogs-tags-li", function(){
  if($(this).hasClass("active")){
    $(this).removeClass("active");
    $(".custom-blogs-item").fadeIn(300);
  }
  else{
    $(".custom-blogs-tags-li").removeClass("active");
    $(this).addClass("active");
    let title = $(this).attr("data-title");
    $(".custom-blogs-item").hide();
    $(".custom-blogs-item").each(function(){
      if($(this).attr("data-tags").indexOf(title) != -1){
        $(this).fadeIn(300);
      }
    })
  }
})